const PHRASES = [
  "Pigment & water on cotton rag",
  "Original watercolor notecards",
  "Individual 3 × 5 notecards",
  "Plein air atmosphere",
  "Willamette Valley & coastal views",
  "Worldwide careful packaging",
  "Small artwork, big impact",
];

export default function Marquee({ dark = false }) {
  const row = [...PHRASES, ...PHRASES];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y ${dark ? "border-linen/10 bg-night text-linen/70" : "border-ink/10 bg-paper text-stone2"} py-4 select-none`}
      aria-hidden="true"
    >
      <div className="flex whitespace-nowrap animate-marquee-slow w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {row.map((p, i) => (
              <span key={`${half}-${i}`} className="flex items-center font-mono text-[11px] uppercase tracking-[0.3em]">
                <span className="px-6">{p}</span>
                <span className={dark ? "text-ochre" : "text-terracotta"}>✳</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
